export default __webpack_public_path__ + "8203ffd930a121965cecfb797136ec95.png";